// import RoundCamera from "../../Images/Products/view-round-modern-webcam-with-copy-space.jpg";

// // import Animatedvideo2 from "../../Videos/0_Circuit Board_Technology_1280x720.mp4";
// import Animatedvideo2 from "../../Videos/3141208-hd_1920_1080_25fps.mp4";
// // import Animatedvideo2 from "../../Videos/6914770_Motion Graphics_Motion Graphic_1920x1080.mp4";
// import { BsGear } from "react-icons/bs";
// import { LuCctv } from "react-icons/lu";
// import { GrStorage } from "react-icons/gr";
// import { MdOutlineChatBubbleOutline } from "react-icons/md";
// import { useNavigate } from "react-router-dom";

// const ProductCarousel = () => {
//   const navigate = useNavigate();
//   return (
//     <div className="w-full absolute h-full overflow-hidden flex items-center justify-center">
//       {/* <img
//         src={RoundCamera}
//         cl/ data-aos="fade-up"
//           /assName="w-full h-96 object-cover"
//         alt={{ RoundCamera }}
//       /> */}

//       <div className="flex flex-col gap-5 items-center absolute w-[75%]">
//         <h1
//           data-aos-duration={1000}
//           data-aos-offset="300"
//           data-aos-easing="linear"
//           data-aos="fade-up"
//           // data-aos-anchor-placement="center-center"
//           className="text-5xl font-bold text-center"
//         >
//           Secure Your Home with Our CCTV Solutions
//         </h1>
//         <p
//           data-aos-duration={1200}
//           data-aos-easing="linear"
//           data-aos="fade-up"
//           className=" text-center font-bold mt-4"
//         >
//           Explore Our Range of High-Quality CCTV Cameras and Accessories
//         </p>
//         <button
//           onClick={() => navigate("/contact-us")}
//           data-aos-duration={1400}
//           data-aos-easing="linear"
//           data-aos="fade-up"
//           className="border border-white uppercase text-sm px-6 py-2 hover:border-error cursor-pointer z-10 duration-500 ease-linear"
//         >
//           get a quote
//         </button>
//       </div>

//       <div className="absolute bottom-10 w-full flex justify-around uppercase">
//         <div
//           data-aos="fade-zoom-in"
//           data-aos-easing="ease-in-back"
//           data-aos-delay="500"
//           data-aos-offset="0"
//           className="flex flex-col items-center gap-2"
//         >
//           <LuCctv size={40} className="text-center " />
//           <p>Installation</p>
//         </div>
//         <div
//           data-aos="fade-zoom-in"
//           data-aos-easing="ease-in-back"
//           data-aos-delay="500"
//           data-aos-offset="0"
//           className="flex flex-col items-center gap-2"
//         >
//           <BsGear size={40} /> <p>Maintenance</p>
//         </div>
//         <div
//           data-aos="fade-zoom-in"
//           data-aos-easing="ease-in-back"
//           data-aos-delay="500"
//           data-aos-offset="0"
//           className="flex flex-col items-center gap-2"
//         >
//           <GrStorage size={40} /> <p>storage & backup</p>
//         </div>
//         <div
//           data-aos="fade-zoom-in"
//           data-aos-easing="ease-in-back"
//           data-aos-delay="500"
//           data-aos-offset="0"
//           className="flex flex-col items-center gap-2 hover:translate-y-1/4 transform duration-500 ease-linear"
//         >
//           <MdOutlineChatBubbleOutline size={40} className="" />{" "}
//           <p>consultation</p>
//         </div>
//       </div>

//       <div className="w-full bg-black h-full ">
//         {/* <img
//           src={RoundCamera}
//           alt={{ RoundCamera }}
//           className="max-h-full w-full object-cover"
//         /> */}

//         <video
//           className=" w-full max-  h-full object-cover"
//           // className=" w-full object-cover fixed"
//           height="500"
//           autoPlay
//           loop
//           muted
//         >
//           <source src={Animatedvideo2} type="video/mp4" />
//         </video>
//       </div>

//       <div className="absolute bottom-0 left-0 w-full h-14 bg-gradient-to-t from-bgBlack to-transparent"></div>
//     </div>
//   );
// };

// export default ProductCarousel;

import RoundCamera from "../../Images/Products/view-round-modern-webcam-with-copy-space.jpg";
import cctv from "../../Images/Carousel/cctv.jpg";
import alaram from "../../Images/Carousel/security alarm.jpg";
import telecom from "../../Images/Carousel/telecom.jpg";
import telecom1 from "../../Images/Carousel/telecom2.jpg";
import solarInstallation from "../../Images/Carousel/solar.jpg";
// import Animatedvideo2 from "../../Videos/0_Circuit Board_Technology_1280x720.mp4";
import Animatedvideo2 from "../../Videos/3141208-hd_1920_1080_25fps.mp4";
// import Animatedvideo2 from "../../Videos/6914770_Motion Graphics_Motion Graphic_1920x1080.mp4";
import { BsGear } from "react-icons/bs";
import { LuCctv } from "react-icons/lu";
import { GrStorage } from "react-icons/gr";
import { MdOutlineChatBubbleOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Carousel } from "antd";

const carouseljson = [
  {
    id: 1,
    imageUrl: cctv,
    title: "Secure Your Home with Our CCTV Solutions",
    description:
      " Explore Our Range of High-Quality CCTV Cameras and Accessories",
  },
  {
    id: 2,
    imageUrl: alaram,
    title: "Secure Your Home with Our Security System Integration Services",
    description:
      " Explore Our Range of High-Quality CCTV Cameras and Accessories",
  },
  {
    id: 3,
    imageUrl: telecom1,
    title: "Connect Your Home with Our Telecom Infrastructure Services",
    description:
      " Explore Our Range of High-Quality CCTV Cameras and Accessories",
  },
  {
    id: 4,
    imageUrl: solarInstallation,
    title: "Power Your Home with Our Solar Solutions",
    description:
      " Explore Our Range of High-Quality CCTV Cameras and Accessories",
  },
];

const ProductCarousel = () => {
  const navigate = useNavigate();
  return (
    <section className="relative">
      <Carousel
        autoplay={{ dotDuration: true }}
        autoplaySpeed={2000}
        className="w-full lg:h-[32rem] md:h-[28rem] sm:h-96 h-60 overflow-hidden flex items-center"
      >
        {carouseljson?.length &&
          carouseljson.map((item) => {
            const { id, imageUrl, title, description } = item;

            return (
              <div
                key={id}
                className="flex relative w-full items-center mx-auto"
              >
                <div className="lg:h-[32rem] md:h-[28rem] sm:h-96 h-60 w-full">
                  <img
                    src={imageUrl}
                    className="w-full h-full flex-shrink-0 object-cover"
                    alt={title}
                  />
                </div>

                <div className="flex flex-col md:gap-5 sm:gap-3 gap-3 items-start justify-center absolute text-error left-[2%] sm:top-[20%] top-[10%] md:w-[48%] sm:w-[50%] w-[65%] z-30 ">
                  <h2
                    data-aos-duration={1000}
                    data-aos-offset="300"
                    data-aos-easing="linear"
                    data-aos="fade-up"
                    // data-aos-anchor-placement="center-center"
                    className="lg:text-5xl md:text-3xl sm:text-xl text-base font-bold sm:leading-normal leading-4"
                  >
                    {title}
                  </h2>
                  <p
                    data-aos-duration={1200}
                    data-aos-easing="linear"
                    data-aos="fade-up"
                    className="sm:text-base text-xs font-semibold"
                  >
                    {description}
                  </p>
                  <button
                    onClick={() => navigate("/contact-us")}
                    data-aos-duration={1400}
                    data-aos-easing="linear"
                    data-aos="fade-up"
                    className="border border-white uppercase sm:text-sm text-xs sm:px-6 px-4 sm:py-2 py-1 hover:border-error cursor-pointer z-10 duration-500 ease-linear"
                  >
                    get a quote
                  </button>
                </div>
              </div>
            );
          })}

        {/* <div className="absolute bottom-0 left-0 w-full h-14 bg-gradient-to-t from-bgBlack to-transparent"></div> */}
      </Carousel>
      {/* <div className="bg-lightGray opacity-20 blur-3xl w-[52%] h-full z-10 top-0 absolute"></div> */}
    </section>
  );
};

export default ProductCarousel;
